import React, { useEffect, useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import logo from '../../logo.jpg';
import {
  getDevInvitationPassword,
  isDevInvitationSessionActive,
  tryDevInvitationLogin,
} from '../utils/invitationGateDev.js';

export default function PasswordGate({ onAuthorized }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      if (isDevInvitationSessionActive()) {
        onAuthorized && onAuthorized();
        return;
      }
      try {
        const res = await fetch('/api/beta-verify', { credentials: 'include', cache: 'no-store' });
        if (!mounted) return;
        const data = res.ok ? await res.json().catch(() => ({})) : {};
        if (data?.authorized) {
          onAuthorized && onAuthorized();
        } else {
          setChecking(false);
        }
      } catch (e) {
        if (mounted) setChecking(false);
      }
    };
    check();
    return () => (mounted = false);
  }, [onAuthorized]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('/api/beta-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: (username || '').trim(), password }),
        credentials: 'include',
      });
      if (res.ok) {
        onAuthorized && onAuthorized();
      } else {
        const j = await res.json().catch(() => ({}));
        if (j.error === 'server_misconfigured' || res.status === 503) {
          setError(
            j.message ||
              'Falta configurar BETA_AUTH_SECRET y BETA_MASTER_PASSWORD en Vercel (o en .env.local con vercel dev).',
          );
        } else if (res.status === 404 || res.status === 502) {
          if (tryDevInvitationLogin(password)) {
            onAuthorized && onAuthorized();
            return;
          }
          const devPw = getDevInvitationPassword();
          setError(
            devPw
              ? 'API local no disponible. Si la contraseña coincide con REACT_APP_BETA_DEV_PASSWORD, debería entrar; reinicia npm start tras cambiar .env.'
              : 'Con «npm start» no hay /api/beta-login. Crea .env.development.local con REACT_APP_BETA_DEV_PASSWORD=tu_clave (reinicia npm start) o usa «npx vercel dev --listen 3001» en otra terminal.',
          );
        } else {
          setError(j.message || j.error || 'Credenciales incorrectas');
        }
      }
    } catch (err) {
      if (tryDevInvitationLogin(password)) {
        onAuthorized && onAuthorized();
        return;
      }
      setError('Error de red. Si usas npm start, define REACT_APP_BETA_DEV_PASSWORD en .env.development.local.');
    }
  };

  if (checking) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2000, background: '#050507', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ position: 'absolute', top: 20, right: 20, background: 'rgba(255,165,0,0.12)', border: '1px solid rgba(255,165,0,0.28)', borderRadius: 8, padding: '6px 12px', color: '#FFa500', fontWeight: 700 }}>🚀 PRÓXIMAMENTE</div>

      <div style={{ width: 360, textAlign: 'center', color: '#fff' }}>
        <img src={logo} alt="DreamVinyl" style={{ width: 140, borderRadius: 16, marginBottom: 18 }} />
        <h2 style={{ margin: '8px 0', fontSize: '1.6rem' }}>ACCESO POR INVITACIÓN</h2>
        <p style={{ color: 'rgba(255,255,255,0.65)', marginBottom: 18 }}>
          Pon tu nombre y la contraseña de invitación para acceder.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Usuario (opcional)" style={{ padding: '10px 12px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.08)', background: '#111', color: '#fff' }} />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Contraseña" style={{ padding: '10px 12px', borderRadius: 6, border: `1px solid ${error ? '#ff6666' : 'rgba(255,255,255,0.08)'}`, background: '#111', color: '#fff' }} />
          {error && <div style={{ color: '#ff8888', fontSize: '0.9rem' }}>{error}</div>}
          <button type="submit" style={{ marginTop: 6, padding: '10px 12px', borderRadius: 6, background: C.gold, border: 'none', fontWeight: 800, cursor: 'pointer' }}>ACCEDER</button>
        </form>

        <div style={{ marginTop: 14, fontSize: '0.8rem', color: 'rgba(255,255,255,0.38)', lineHeight: 1.5 }}>
          Si no tienes invitación, escríbenos a{' '}
          <a href="mailto:contacto@dreamvinyl.es" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontWeight: 700 }}>
            contacto@dreamvinyl.es
          </a>
          .
        </div>
      </div>
    </div>
  );
}
